var exports = {
  "Lt": "x93eb46d8--9c1995--select",
  "Ld": "x93eb46d8--9c1995--native-select",
  "Hw": "x93eb46d8--9c1995--mobile",
  "Iw": "x93eb46d8--9c1995--select-popup",
  "Oz": "x93eb46d8--9c1995--upward",
};

module.exports = exports;
